import get from 'lodash/get'

export const isDisableViewingTimeMetrics = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled }) => name === 'disableViewingTimeMetrics' && enabled === true)

}
